enum AgencyStatic {
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @type public
   * @description get agencies list
   */
  agencyPublicList = "/v2/agencies",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @type public
   * @description get agencies list
   */
  agencyCreate = "/v2/admin/agencies/create",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @type private
   * @description get agencies list
   */
  agencyPrivateList = "/v2/admin/agencies",
  /**
   * @member {string}
   * @method get
   * @version 1.0
   * @description get agencies list
   */
  agencyListDrop = "/v1/admin/generic/dropdowns"
}

const AgencyDynamic = {
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description google social network login
   */
  agenciesDetail: (id: number | string) => `/v2/admin/agencies/${id}`,
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description google social network login
   */
  agenciesUpdate: (id: number | string) =>
    `/v2/admin/agencies/${id}/update?_method=PUT`,

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description  activate agency function
   */
  agenciesActivate: (id: number | string) =>
    `/v2/admin/agencies/${id}/enable`,

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description deactivate agency function
   */
  agenciesDeactivate: (id: number | string) =>
    `/v2/admin/agencies/${id}/disable`
};

export const AgencyEndpoints = {
  ...AgencyDynamic,
  ...AgencyStatic
};

export type AgencyEndpoints = typeof AgencyEndpoints;
